import { applyMode, Mode } from "@cloudscape-design/global-styles";

/** Key này đã được bản UI trước dùng, giữ nguyên để không mất lựa chọn của người dùng cũ. */
export const THEME_STORAGE_KEY = "facego_member_theme";

export type ColorMode = "light" | "dark";

export function readStoredMode(): ColorMode {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function storeMode(mode: ColorMode): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    // Chế độ riêng tư chặn localStorage; giao diện vẫn đổi, chỉ không nhớ được.
  }
}

/*
  Màu nền trang, lấy đúng giá trị token `colorBackgroundLayoutMain` của
  Cloudscape ở mỗi chế độ.

  Không tham chiếu thẳng `var(--color-background-layout-main-…)`: hậu tố băm
  trong tên biến đổi theo mỗi lần nâng cấp Cloudscape, tham chiếu tay là hỏng
  âm thầm. Đo lại bằng cách đọc biến đó trên một phần tử thử, ở cả hai chế độ,
  nếu bản Cloudscape mới đổi màu.
*/
const CANVAS: Record<ColorMode, string> = { dark: "#161d26", light: "#ffffff" };

/**
 * Bật/tắt class awsui-dark-mode, đồng thời sơn nền trang. Màu thương hiệu do
 * brand.generated.css lo — xem scripts/generate-brand-css.mjs để biết vì sao
 * không dùng applyTheme().
 *
 * Class phải đặt trên <body>, không phải <html>: Cloudscape khai báo toàn bộ
 * token gốc ở selector `body`, nên nếu class nằm ở tổ tiên xa hơn thì khai báo
 * của chính body sẽ ghi đè giá trị dark và giao diện không đổi.
 *
 * Phần sơn nền là bắt buộc, không phải trang trí: Cloudscape chỉ tô nền cho
 * từng thành phần, còn khoảng trống quanh chúng thì không ai tô. Trang công
 * khai lại không dùng AppLayout nên vùng đó khá lớn, và trình duyệt lấp bằng
 * màu canvas mặc định của nó — người để máy ở chế độ tối nhìn thấy giao diện
 * theme sáng (chữ #0f141a, link #0077b8) nằm trên nền gần đen, phần chân trang
 * gần như đọc không ra. `colorScheme` đi kèm để thanh cuộn và các control gốc
 * của trình duyệt cũng theo đúng chế độ.
 */
export function applyFaceGoTheme(mode: ColorMode): void {
  applyMode(mode === "dark" ? Mode.Dark : Mode.Light, document.body);
  const root = document.documentElement;
  root.style.colorScheme = mode;
  root.style.backgroundColor = CANVAS[mode];
}
